import styled from 'styled-components';

export const RoutinelistAddInner = styled.div`
    // padding : calc(100vw*(51/375)) 0 calc(100vw*(110/375)) 0;
    padding : 0 0 calc(100vw*(110/375)) 0;
`
export const Calinner = styled.div`
    padding-bottom: calc(100vw*(32.5/375));
`
export const RoutinelistAddTop = styled.p`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: calc(100vw*(46/375));
    background-color: #f7f7f7;
    padding : 0 calc(100vw*(17/375));
    border-bottom: solid calc(100vw*(1/375)) #d8d8d8;
    border-top: ${props=>props.bordertop};
    margin-bottom :  calc(100vw*(21/375));
    
`
export const Toptext = styled.span`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    letter-spacing: -0.34px;
    color: #4e4e4e;
`
export const Topday = styled(Toptext)`
    color: #989898;
`
export const Checkday = styled.div`
    padding : 0 calc(100vw*(17/375));
`